// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__vatyf","guide":"Sidebar_guide__LBvma","tcgland":"Sidebar_tcgland__6fpZx"};